import React from "react";
import { useNavigate, useParams } from "react-router";
import SiteHeader from "../landing/components/Header/SiteHeader";
import Footer from "../landing/components/Footer/Footer";
import useFocusPageStart from "../../hooks/useFocusPageStart";
import Breadcrumb from "../schemes/components/Breadcrumb/Breadcrumb";
import Sidebar from "../schemes/components/Sidebar/Sidebar";
import ResourcesContent from "./components/ResourcesContent/ResourcesContent";
import resourceMenuItems, {
  getResourceSection,
  normalizeResourceSection,
} from "./data/resourceMenuItems";

const PageTitle = ({ label }) => {
  const title = label;

  return (
    <h1 className="m-0 text-[20px] font-bold leading-[1.2] uppercase tracking-[1px] text-[#1b3a6b] md:text-[23px] first-letter:text-[#ff9933]">
      {title}
    </h1>
  );
};

const ResourcesPage = ({
  basePath = "/resources",
  pageLabel = "Resources",
  menuItems = resourceMenuItems,
  getSection = getResourceSection,
  normalizeSection = normalizeResourceSection,
}) => {
  const navigate = useNavigate();
  const { section, resourceDocument } = useParams();
  const activeSection = normalizeSection(section);
  const currentSection = getSection(activeSection);
  const currentSectionTitle = currentSection.pageTitle || currentSection.label;
  const resourceDocumentTitle =
    activeSection === "resource-documents" &&
    resourceDocument === "memorandum-of-understanding"
      ? "Memorandum of Understanding"
      : "";
  const scrollKey = `${basePath}/${section || activeSection}/${
    resourceDocument || ""
  }`;

  const handleSelectSection = (sectionId) => {
    navigate(`${basePath}/${sectionId}`);
  };

  useFocusPageStart(scrollKey);

  const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: pageLabel, path: basePath },
    { label: currentSectionTitle, path: `${basePath}/${activeSection}` },
    ...(resourceDocumentTitle
      ? [
          {
            label: resourceDocumentTitle,
            path: `${basePath}/${activeSection}/${resourceDocument}`,
          },
        ]
      : []),
  ];

  return (
    <div className="flex min-h-screen flex-col bg-[#f5f5f5]">
      <SiteHeader className="shadow-[0_2px_4px_rgba(0,0,0,0.1)]">
        <div className="z-[1000] px-4 pt-2 pb-3 md:px-20 md:pb-4">
          <Breadcrumb items={breadcrumbItems} />
        </div>
      </SiteHeader>

      <main
        id="main-content"
        data-readable-content
        tabIndex={-1}
        className="flex-1 outline-none"
      >
        <div className="px-4 pt-7 pb-3.5 md:px-20 md:pb-[18px]">
          <PageTitle label={currentSectionTitle} />
        </div>

        <div className="mx-auto flex min-h-[360px] w-full max-w-[1400px] flex-col gap-5 px-5 pb-16 pt-5 md:min-h-[420px] md:px-10 md:pb-24 md:pt-10 lg:flex-row lg:items-start lg:gap-[30px]">
          <Sidebar
            activeSection={activeSection}
            onSelectSection={handleSelectSection}
            menuItems={menuItems}
          />
          <ResourcesContent
            activeSection={activeSection}
            currentSection={currentSection}
            resourceDocument={resourceDocument}
          />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ResourcesPage;
